import React from "react";
import styled from "styled-components";

const StyledRowImage = styled.img`
  margin: ${(props) => props.margin}px;
  display: block;
  cursor: ${(props) => (props.isVideo ? "pointer" : "default")};
`;

//   left: ${(props) => props.left}px;
//   top: ${(props) => props.top}px;
//   display: block;
const StyledColumnImage = styled.img`
  margin: ${(props) => props.margin}px;
  cursor: ${(props) => (props.isVideo ? "pointer" : "default")};
  position: absolute;
`;

const FlexDiv = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  left: ${(props) => props.left}px;
  top: ${(props) => props.top}px;
  margin: ${(props) => props.margin}px;
`;

function StyledColumnImageOrVideo(props) {
  const playSrc = {
    src: "/care/play_icon.svg",
    width: "25%",
    height: "25%",
  };
  return (
    <FlexDiv
      width={props.width}
      height={props.height}
      left={props.left}
      top={props.top}
      margin={props.margin}
    >
      <StyledColumnImage {...props}></StyledColumnImage>
      <StyledColumnImage {...props} {...playSrc}></StyledColumnImage>
      {props.isVideo && (
        <StyledColumnImage {...props} {...playSrc}></StyledColumnImage>
      )}
    </FlexDiv>
  );
}

const ImageRenderer = (props) => {
  const photo = props.photo;
  const index = props.index;
  const handleClick = (event) => {
    props.onClick(event, { photo, index });
  };

  return (
    <React.Fragment key={props.key}>
      {props.direction === "column" ? (
        <StyledColumnImageOrVideo
          key={props.key}
          isVideo={props.photo.mediatype === "video"}
          margin={props.margin}
          left={props.left}
          top={props.top}
          {...props.photo}
          onClick={props.onClick ? handleClick : null}
        ></StyledColumnImageOrVideo>
      ) : (
        <StyledRowImage
          key={props.key}
          isVideo={props.photo.mediatype === "video"}
          margin={props.margin}
          {...props.photo}
          onClick={props.onClick ? handleClick : null}
        ></StyledRowImage>
      )}
    </React.Fragment>
  );
};

export default ImageRenderer;
